import { render, staticRenderFns } from "./DDNSSettings.vue?vue&type=template&id=6664d2aa&"
import script from "./DDNSSettings.vue?vue&type=script&lang=js&"
export * from "./DDNSSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports